//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import SAP_BASIC_1Function from '../SAP_BASIC_01/SAP_BASIC_01F';
import SAP_BASIC_2Function from '../SAP_BASIC_02/SAP_BASIC_02F';
import { setStartDate, setEndDate } from '../../../../Reducer/SearchReducer';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0, // ✅ flex container 하에서 overflow 계산 가능하게 함
          }}
        >
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SAP_BASIC(props) {
  const dispatch = useDispatch();
  //#region 변수
  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SafetyPersonnel"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          deleteYn="Y"
          printYn={props.value === 1 ? 'Y' : 'N'}
          // fileYn={props.value === 1 ? 'Y' : 'N'}
          fileValidFc={() => {
            if (!props.validateSelection()) {
              return false; // 실패
            }
            return true; // 성공
          }}
          addClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setAddClick1(true);
            } else if (props.value === 1) {
              props.setAddClick2(true);
            }
          }}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            props.searchRef.current.searchText = e;
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick2(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            }
          }}
          deletePayload1={props.deletePayload1}
          searchPayload1={props.searchPayload1}
          savePayload1={props.savePayload1}
          saveFilePath1={`Business/${props.searchInfo.custCd}/SAP_FILE`}
          custCd={props.searchInfo.custCd} // ✅ 추가
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchInfo.coList,
                    value: props.searchInfo.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);

                      if (props.value === 0) {
                        props.setSearchClick1(true);
                      } else {
                        props.setSearchClick2(true);
                      }
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo.custList,
              value: props.searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);

                if (props.value === 0) {
                  props.setSearchClick1(true);
                } else {
                  props.setSearchClick2(true);
                }
              },
            },
          ]}
          grids={
            <React.Fragment>
              <Box sx={{ mb: 1 }}>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  variant="scrollable"
                  scrollButtons={false}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="안전보건 조직도"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="안전보건 조직 구성"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <SAP_BASIC_1Function
                  startDate={props.searchRef.current.startDate}
                  endDate={props.searchRef.current.endDate}
                  custCd={props.searchRef.current.custCd}
                  searchText={props.searchRef.current.searchText}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  listClick1={props.listClick1}
                  setListClick1={props.setListClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <SAP_BASIC_2Function
                  searchRef={props.searchRef}
                  custCd={props.searchRef.current.custCd}
                  searchText={props.searchRef.current.searchText}
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  listClick2={props.listClick2}
                  setListClick2={props.setListClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default SAP_BASIC;
